export default __webpack_public_path__ + "static/media/Wreath of Ether.b982bc95.jpg";